import tw from "twin.macro";
import React from "react";

type Props = {
  variant?: keyof typeof variants;
  clamp?: boolean;
  [key: string]: unknown;
};

const variants = {
  "solid-light-grey": tw`bg-grey-40-light`,
  "solid-grey": tw`bg-grey-50-light`,
  "solid-green": tw`bg-green-80 text-white-100-light`,
  "solid-blue": tw`bg-blue-100 text-white-100-light`,
  blur: tw`bg-grey-50-light/20 backdrop-blur text-white-100-light`,
  "transparent-20": tw`bg-transparent-20 text-white-100-light backdrop-blur-[16px]`,
} as const;

const hovers = {
  "solid-light-grey": tw`hover:bg-grey-50-light`,
  "solid-grey": tw`hover:bg-grey-100-dark`,
  "solid-green": tw`hover:bg-green-100`,
} as const;

export function Tag(props: React.PropsWithChildren<Props>) {
  const { variant = "solid-grey", clamp, ...rest } = props;
  const hasHover = "href" in rest || "onClick" in rest;

  return (
    <div
      css={[
        tw`inline-block p-8 text-black-100-light min-h-[3.2rem] text-mobile-caption-20-normal font-aeonik rounded-2 lg:text-desktop-caption-20-normal transition-colors duration-250 ease-in-out`,
        variants[variant],
        hasHover ? hovers[variant as keyof typeof hovers] : undefined,
        clamp && tw`whitespace-nowrap overflow-hidden text-ellipsis`,
      ]}
      {...rest}
    />
  );
}
